import html from "nanohtml";
import type { WidgetUIProps } from "../../types.ts";
import { ArticleCardHorizontalV2 } from "../components/articleCardHorizontalV2.ts";

const SI_TITLE = "Today's best reads";

export function CardStackV2(props: WidgetUIProps): HTMLElement {
  const widgetId = `rw-widget-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 11)}`;

  function isDomainSiCom(url: string): boolean {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname.includes('si.com');
    } catch {
      return false;
    }
  }
    
  function getTitleColorClass(url: string): string {
    return isDomainSiCom(url) ? 'rw-text-primary rw-text-base rw-font-weight-700 md:rw-text-2xl md:rw-leading-[30px]' : 'rw-text-xl rw-text-black';
  }

  if(isDomainSiCom(props.posts[0].url)) {
    props.title = SI_TITLE;
  }

  return html`
    <div
      class="rw-widget rw-my-4 renderer-${props.siteRenderer}"
      role="region"
      aria-labelledby="${widgetId}-title"
    >
      <div class="rw-mb-3">
        <hr class="v2 rw-mb-4" aria-hidden="true" />
        <h2 id="${widgetId}-title" class="rw-title-font rw-m-0 ${getTitleColorClass(props.posts[0].url)}">
          ${props.title}
        </h2>
      </div>
      <nav role="navigation" aria-label="Related articles">
        ${props.posts.map((post, index) => {
          return html`<div class="rw-mb-2">
            ${ArticleCardHorizontalV2({
              ...post,
              logger: props.logger,
            })}
          </div>`;
        })}
      </nav>
      <div class="rw-sr-only" aria-live="polite">
        ${props.posts.length} related articles loaded
      </div>
    </div>
  `;
}
